import { ILiferay } from '../interfaces/liferay';

// eslint-disable-next-line no-var
declare const Liferay: ILiferay;

const INTEREST_RATE_TAG = 'interest-rate';
const PRODUCT_NAME_ATTRIBUTE = 'productName';
const DEFAULT_LOCALE = 'de_DE';

const GROUP_ID = Liferay.ThemeDisplay.getScopeGroupId();
const PRODUCTS_INTEREST_RATES_REST_URL = `/o/products-interest-rates/${GROUP_ID}`;

const TRANSLATIONS: {
  errorMessage: { [key: string]: string };
  noInterestRateMessage: { [key: string]: string };
} = {
  errorMessage: {
    de_DE:
      'Derzeit können leider nicht alle Informationen abgerufen werden. Bitte probieren Sie es später noch einmal.',
    en_US: 'Unfortunately not all information can be retrieved at the moment. Please try again later.',
    it_IT: 'Purtroppo non tutte le informazioni possono essere recuperate al momento. Per favore, riprovi più tardi.',
    fr_FR: "Toutes les informations n'ont pas pu être chargées. Veuillez rééssayer plus tard.",
  },
  noInterestRateMessage: {
    de_DE: '-/-',
    en_US: '-/-',
    it_IT: '-/-',
    fr_FR: '-/-',
  },
};

const getLocale = (): string => {
  let locale = DEFAULT_LOCALE;
  if (Liferay) {
    locale = Liferay.ThemeDisplay.getLanguageId() || locale;
  }
  return locale.replace('-', '_');
};

const getErrorMessage = (): string => {
  const locale = getLocale();

  const message: string = TRANSLATIONS.errorMessage[locale] || TRANSLATIONS.errorMessage[DEFAULT_LOCALE];

  return message;
};

const getNoInterestRateMessage = (productName: string): string => {
  const locale = getLocale();

  const message: string =
    TRANSLATIONS.noInterestRateMessage[locale] || TRANSLATIONS.noInterestRateMessage[DEFAULT_LOCALE];

  return message.replace('%%KEY%%', productName);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const handleInterestRateReplacement = (response: any[]): void => {
  const dateNow = new Date();

  $(INTEREST_RATE_TAG).each((_index, element) => {
    const productName = element
      .getAttribute(PRODUCT_NAME_ATTRIBUTE)
      .trim()
      .toLowerCase();

    let interestRate = getNoInterestRateMessage(productName);
    let selectedRate: { date: Date } | null = null;

    $.each(response, (_index, value) => {
      if (
        value.productName.trim().toLowerCase() === productName &&
        value.date <= dateNow &&
        (!selectedRate || selectedRate.date < value.date)
      ) {
        interestRate = value.interestRate;
        selectedRate = value;
      }
    });

    element.innerHTML = interestRate;
  });
};

const replaceInterestRateTags = (): void => {
  $.get(PRODUCTS_INTEREST_RATES_REST_URL, response => {
    handleInterestRateReplacement(response);
  }).fail(() => {
    $(INTEREST_RATE_TAG).each((_index, element) => {
      element.innerHTML = '-';
    });
    $('header').append(`<div class="alert alert-error-2">${getErrorMessage()}</div>`);
  });
};

export const initInterestRates = (): void => {
  if ($(INTEREST_RATE_TAG).length > 0) {
    replaceInterestRateTags();
  }
};
